import React from "react";
import styled from "styled-components";
import Select from "react-select";
import moment from "moment";

import { Text } from "@appcues/component-library";
import Input from "components/Common/Forms/Input";
import RadioButton from "components/Common/Forms/RadioButton";
import ToggleableInput from "components/Common/Clauses/ToggleableInput";
import { exportModalMessages } from "constants/modalMessages";

const ExportInputFields = props => {
  const {
    exportMode,
    includeFormResponsesOption,
    formResponsesOnly,
    createdAt,
    dateRange,
    email,
    endDate,
    handleEmailChange,
    handleEnterPress,
    handleExportModeChange,
    handleFormResponsesChange,
    handleDateRangeSelect,
    handleStartDateSelect,
    handleEndDateSelect,
    startDate
  } = props;

  const dateRangeOptions = [
    { value: createdAt, label: "All Time" },
    { value: 30, label: "Last 30 Days" },
    { value: 90, label: "Last 90 Days" },
    { value: "custom", label: "Custom Date Range" }
  ];

  // note: CCheckbox doesn't work here because it's written as more of
  // a multi-select, hard to make it work as actual checkbox
  return (
    <InputFieldsWrapper>
      <ExportHeading className="export-label" for="date-range-select">
        Export Options
      </ExportHeading>
      <RadioButton
        checked={exportMode === "basic"}
        label="Basic"
        name="basic"
        onChange={() => handleExportModeChange("basic")}
        optionDescription={exportModalMessages.basic}
        value="basic"
      />
      <RadioButton
        checked={exportMode === "full"}
        label="Full"
        name="full"
        onChange={() => handleExportModeChange("full")}
        optionDescription={exportModalMessages.full}
        value="full"
      />
      {includeFormResponsesOption && (
        <InputFieldsWrapper>
          <ExportHeading>Filters</ExportHeading>
          <label>
            <StyledCheckbox
              type="checkbox"
              defaultChecked={formResponsesOnly}
              onChange={handleFormResponsesChange}
            />
            <VertAlignedLabelText>
              Only include events with form responses
            </VertAlignedLabelText>
          </label>
        </InputFieldsWrapper>
      )}
      <FieldWrapper>
        <SelectWrapper>
          <ExportHeading className="export-label" for="date-range-select">
            <strong>Date Range</strong>
          </ExportHeading>
          <Select
            clearable={false}
            name="date-range-select"
            onChange={handleDateRangeSelect}
            options={dateRangeOptions}
            value={dateRange}
          />
        </SelectWrapper>
        {dateRange === "custom" && (
          <DatePickerWrapper>
            <DateInputWrapper>
              <DateRangeLabel className="date-range-label">
                Start:
              </DateRangeLabel>
              <ToggleableInput
                datePicker
                maxDate={moment()}
                minDate={moment(createdAt)}
                onChange={handleStartDateSelect}
                selected={startDate}
              />
            </DateInputWrapper>
            <DateInputWrapper>
              <DateRangeLabel className="date-range-label">End:</DateRangeLabel>
              <ToggleableInput
                datePicker
                minDate={moment(createdAt)}
                maxDate={moment()}
                onChange={handleEndDateSelect}
                selected={endDate}
              />
            </DateInputWrapper>
          </DatePickerWrapper>
        )}
        <ExportHeading className="export-label" for="email-input">
          <strong>Email Address</strong> &#8212; we&#8217;ll send your CSV here
        </ExportHeading>
        <EmailInputWrapper>
          <Input
            name="email-input"
            onKeyPress={handleEnterPress}
            onChange={handleEmailChange}
            type="text"
            value={email}
          />
        </EmailInputWrapper>
      </FieldWrapper>
    </InputFieldsWrapper>
  );
};

const InputFieldsWrapper = styled.div`
  margin: 18px 0;
`;

const EmailInputWrapper = styled.div`
  display: flex;

  input {
    width: 100%;
  }
`;

const FieldWrapper = styled.div`
  margin-top: 13px;
`;

const ExportHeading = styled(Text)`
  font-weight: bold;
  display: block;
  margin-bottom: 16px;
`;

const StyledCheckbox = styled.input`
  width: 18px;
  height: 18px;
`;

/**
 * Not using Box props here because Box doesn't support
 * vertical align for some reason
 */
const VertAlignedLabelText = styled(Text)`
  font-size: 16px;
  margin-left: 10px;
  vertical-align: top;
  line-height: 16px;
`;

const SelectWrapper = styled.div`
  margin-bottom: 16px;
`;

const DatePickerWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 24px;
`;

const DateInputWrapper = styled.div`
  width: calc(50% - 8px);

  .react-datepicker-wrapper {
    width: 100%;
  }

  .react-datepicker__input-container {
    width: 100%;
  }

  input {
    width: 100%;
  }
`;

const DateRangeLabel = styled.label`
  &.date-range-label {
    display: block;
    margin-bottom: 8px;
  }
`;

export default ExportInputFields;
